
import { Badge } from "@/components/ui/badge";
import { CheckCircle, MapPin } from "lucide-react";
import { motion } from "framer-motion";

interface ProfileHeaderProps {
  imageUrl: string;
  firstName: string;
  lastName: string;
  city?: string;
  state?: string;
  isCertified: boolean;
}

export const ProfileHeader = ({
  imageUrl,
  firstName,
  lastName,
  city,
  state,
  isCertified
}: ProfileHeaderProps) => {
  return (
    <div className="space-y-4">
      <motion.div 
        initial={{
          opacity: 0,
          y: 20
        }} 
        animate={{
          opacity: 1,
          y: 0
        }} 
        className="flex flex-col md:flex-row items-center gap-6"
      >
        <div className="w-32 h-32 rounded-full overflow-hidden bg-gray-100">
          <img 
            src={imageUrl || "https://via.placeholder.com/128"} 
            alt={`${firstName} ${lastName}`} 
            className="w-full h-full object-cover" 
          />
        </div>
        <div className="text-center md:text-left space-y-2">
          <div className="flex flex-col items-center md:items-start gap-2">
            <h1 className="text-2xl font-semibold text-black">
              {firstName} {lastName}
            </h1>
            
            {(city || state) && (
              <p className="text-black flex items-center gap-1 justify-center md:justify-start">
                <MapPin className="w-4 h-4" />
                {[city, state].filter(Boolean).join(", ")}
              </p>
            )}

            {isCertified && (
              <Badge variant="outline" className="bg-green-50/50 text-green-700 border-green-200 flex items-center gap-1.5 px-3 py-1 rounded-full">
                <CheckCircle className="w-4 h-4" />
                Certified Kitchen
              </Badge>
            )}
          </div>

          {isCertified && (
            <p className="text-sm text-green-700 mt-2">
              This Chef has been certified with a clean kitchen and proper food handling skills
            </p>
          )}
        </div>
      </motion.div>
    </div>
  );
};
